import { render, staticRenderFns } from "./CopyRbacModal.vue?vue&type=template&id=ee7db4d2&scoped=true&"
import script from "./CopyRbacModal.vue?vue&type=script&lang=js&"
export * from "./CopyRbacModal.vue?vue&type=script&lang=js&"
import style0 from "./CopyRbacModal.vue?vue&type=style&index=0&id=ee7db4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7db4d2",
  null
  
)

export default component.exports